import styled from "styled-components";

import { rem } from "@ui/helpers";

const Item = styled.li`
  display: flex;
  align-items: center;
  height: ${rem(64)};
  border-bottom: 1px solid ${props => props.theme.palette.grey100};
  gap: ${props => props.theme.margins.base_x1_5};
  cursor: pointer;
  text-align: left;
`;

const Arrow = styled.div`
  grid-area: arrow;
  flex: 0 0 ${rem(32)};
  color: ${props => props.theme.palette.grey600};
`;

const Icon = styled.div`
  display: flex;
  color: ${props => props.theme.palette.blue500};
  flex: 0 0 ${rem(32)};
  font-size: ${props => props.theme.fonts.sizes.h4};
`;

const Text = styled.div`
  grid-area: text;
  flex: 1 1 100%;
  font-size: ${props => props.theme.fonts.sizes.body};
`;

export const SectionMenuStyles = {
  Item,
  Arrow,
  Icon,
  Text,
};
